import { forwardRef, InputHTMLAttributes } from 'react';
import { DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

import DownArrowIcon from '~components/Icon/DownArrowIcon';

import { S } from './style';
export interface SelectProps extends InputHTMLAttributes<HTMLSelectElement> {
  options: string[];
  label?: string;
  hasError?: boolean;
  fullWidth?: boolean;
  errorMessage?: string;
  inlineWrapperCss?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
  inlineSelectCss?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
}
const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      label,
      options,
      hasError,
      errorMessage,
      inlineWrapperCss,
      inlineSelectCss,
      fullWidth = false,
      ...props
    },
    ref,
  ) => {
    return (
      <S.SelectWrapper inlineWrapperCss={inlineWrapperCss} fullWidth={fullWidth}>
        {label && <S.Label htmlFor={props.id}>{label}</S.Label>}
        <S.StyledSelect
          {...props}
          ref={ref}
          inlineSelectCss={inlineSelectCss}
          hasError={hasError}
          selected={!!props.value}>
          <option value='' disabled selected={!props.value}>
            {props.placeholder ?? 'Please select'}
          </option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </S.StyledSelect>
        <S.ArrowIcon hasLabel={!!label}>
          <DownArrowIcon width={10} height={6} fill={props.disabled ? '#CCCCCC' : '7D7D7D'} />
        </S.ArrowIcon>
        {hasError && (
          <S.Error typography='midium120_C1' as='div'>
            {errorMessage ? errorMessage : '에러가 발생했습니다.'}
          </S.Error>
        )}
      </S.SelectWrapper>
    );
  },
);

Select.displayName = 'Select';

export default Select;
